/**
 * Shared top-of-page brand logo for every exercise/breathing sub-page.
 * Keeps the "Les Mains Nuages" clinic branding consistent across the hub,
 * the challenges intro, the Oxygen Advantage page, the BOLT test, etc.
 */
const BrandLogoBar = ({ className = '', size = 'default' }) => {
  const heightCls = size === 'small'
    ? 'h-10 sm:h-14'
    : 'h-12 sm:h-16 lg:h-20';
  return (
    <div
      className={`flex justify-center ${className}`}
      data-testid="brand-logo-bar"
    >
      <img
        src="/logo-mains-nuages.png"
        alt="Physiothérapie Les Mains Nuages"
        className={`${heightCls} w-auto`}
        style={{ filter: 'drop-shadow(0 2px 6px rgba(15,32,64,0.25))' }}
      />
    </div>
  );
};

export default BrandLogoBar;
